import { ShipStationTermsAndConditionsModal } from '../shipstation-terms';
import { acceptDhlWalletTermsRequest } from '../../../../store/seller/seller.actions';

import { connect } from 'react-redux';

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onAcceptTerms: () => {
      dispatch(acceptDhlWalletTermsRequest());
      if (ownProps.postAcceptanceAction) {
        dispatch(ownProps.postAcceptanceAction);
      }
    },
  };
};

export const ShipstationTermsContainer = connect(null, mapDispatchToProps)(ShipStationTermsAndConditionsModal);
